import { PlaceholderImage } from '../placeholder-image';

export const ImagePlaceholder = () => (
  <div className="flex aspect-square items-center justify-center bg-secondary-light opacity-50" data-testid="imagePlaceholder">
    <PlaceholderImage className="h-20 text-secondary" />
  </div>
);
